import { GetterTree } from "vuex";
import { 
  ShoppingListState,
  RootState,
  ShoppingListFoodList,
  ShoppingListCategoryListItem,
  ShoppingListSceneCategoryList,
  ShoppingListSceneTopCategoryListItem,
  ShoppingListSceneCategoryListChildrenItem
} from "@/types/shoppingList";
import { readShoppingList } from "@/model/storage";
import NativeClient from "@/client/native-client";
import { normalizeClass } from "@vue/shared";

const getters: GetterTree<ShoppingListState, RootState> = {
  // 買い物リスト
  getFoodList: (state: ShoppingListState) => {
    if (state.foodList == null) {
      const jsonString = readShoppingList();
      if (jsonString == undefined || jsonString === null) {
        return null
      }
      const result: ShoppingListFoodList = JSON.parse(jsonString);
      return result;
    }
    return state.foodList;
  },
  // 食材提案リスト
  getRecommendList: (state: ShoppingListState) => {
    return state.recommendList;
  },
  // 消費済み食品リスト
  getConsumedList: (state: ShoppingListState) => {
    return state.consumedList;
  },
  // よく使う食品リスト
  getRankingList: (state: ShoppingListState) => {
    return state.rankingList;
  },
  // お気に入り食品リスト
  getFavoriteList: (state: ShoppingListState) => {
    return state.favoriteList;
  },
  // カテゴリ全体の取得
  getTopCategoryList: (state: ShoppingListState) => {
    if (state.sceneCategoryList == null) {
      NativeClient.sendDebugLog("getters.ts getTopCategoryList result = null");
      return null;
    }
    NativeClient.sendDebugLog("getters.ts getTopCategoryList before array create");
    const result: Array<ShoppingListSceneTopCategoryListItem> = [];
    for(const item of state.sceneCategoryList.categories) {
      const element: ShoppingListSceneTopCategoryListItem = { id: item.id, name: item.name };
      result.push(element);
    }
    NativeClient.sendDebugLog("getters.ts getTopCategoryList result = " + JSON.stringify(result));
    return result;
  },
  // カテゴリ別取得
  getCategoryFooodList: (state: ShoppingListState) => (id: number) => {
    if (state.sceneCategoryList == null) {
      return null;
    }
    let result: Array<ShoppingListSceneCategoryListChildrenItem> = [];
    NativeClient.sendDebugLog("getters.ts getCategoryFooodList data = " + JSON.stringify(state.sceneCategoryList));
    for (const topCategory of state.sceneCategoryList.categories) {
      NativeClient.sendDebugLog("getters.ts getCategoryFooodList topCategory id = " + topCategory.id);
      if (topCategory.id == id) {
        NativeClient.sendDebugLog("getters.ts getCategoryFooodList found id = " + id);
        for (const secondCategory of topCategory.children) {
          result = result.concat(secondCategory.children);
        }
        NativeClient.sendDebugLog("getters.ts getCategoryFooodList result = " + JSON.stringify(result));
        break;
      }
    }
    return result;
  },
  getRegistingFoodList: (state: ShoppingListState) => {
    return state.registingFoodList;
  },
  // 検索結果取得
  getSearchResultList: (state: ShoppingListState) => {
    return state.searchResltList;
  },
  getPreviousSelectCategoryIndex: (state: ShoppingListState) => {
    return state.previousSelectCategoryIndex
  },
  getPantryList: (state: ShoppingListState) => {
    return state.pantryList;
  }
};

export default getters;
